import React, { type ComponentProps, forwardRef } from 'react';
import { Platform, StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';
import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuTopDownCategoriesContainer = forwardRef<
  Animated.ScrollView,
  MenuTopDownCategoriesContainerProps
>((props, ref) => {
  const { children, contentContainerStyle, ...restProps } = props;

  const { bottom: safeAreaBottom } = useSafeAreaInsets();

  const contentContainerDynamicStyles = useStyle(() => {
    const bottomOffset = Platform.select({
      android: safeAreaBottom > 0 ? theme.spacing['4'] : 0,
      default: 0,
    });

    return {
      paddingBottom:
        Math.max(safeAreaBottom, theme.spacing['8']) + bottomOffset,
    };
  }, [safeAreaBottom]);

  return (
    <Animated.ScrollView
      ref={ref}
      contentContainerStyle={[
        styles.contentContainer,
        contentContainerDynamicStyles,
        contentContainerStyle,
      ]}
      {...restProps}
    >
      {children}
    </Animated.ScrollView>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentContainer: {
    paddingHorizontal: theme.spacing['4'],
    rowGap: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuTopDownCategoriesContainerProps = ComponentProps<
  typeof Animated.ScrollView
>;
